import { Component } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import { FACTORS_THRESHOLD } from "helpers/analyzeConstants"
import { factorFormatter, percentageFormatter } from "helpers/formatters/numbers"
import { getFactorDisabled } from "helpers/factors"
import RiskFactor from "../factor"
import "../../style.scss"

class RiskCategory extends Component {
  constructor(...args) {
    super(...args)
    this.state = { open: true }
  }

  static propTypes = {
    total: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    singleFactor: PropTypes.bool,
    formatter: PropTypes.func.isRequired,
    max: PropTypes.number.isRequired,
    factors: PropTypes.array.isRequired,
    openFactorProfile: PropTypes.func.isRequired,
    displayVolatility: PropTypes.bool.isRequired,
  }

  onClick = () => {
    this.setState(state => ({ open: !state.open }))
  }

  openFactorProfile = () => {
    const { openFactorProfile, factors } = this.props
    openFactorProfile(factors[0].id)
  }

  render() {
    const { open } = this.state
    const { total, label, color, formatter, max, factors, openFactorProfile, singleFactor, displayVolatility } = this.props

    if (Math.abs(total) < FACTORS_THRESHOLD) {
      return null
    }

    const classNames = ["category"]

    if (!open) {
      classNames.push("closed")
    }

    const exposure = singleFactor ? factorFormatter(factors[0].exposure) : "-"
    const volatility = singleFactor ? percentageFormatter(factors[0].volatility) : "-"
    const link = singleFactor && !getFactorDisabled(factors[0].category)
      ? <a className="display" onClick={this.openFactorProfile}>{label} Risk</a>
      : <div className="display">{label} Risk</div>

    const chartWidth = Math.abs(total) / max * 100
    return <div className={classNames.join(" ")}>
      <div onClick={this.onClick} className={classnames("total", { "single-factor": singleFactor })}>
        {link}
        <div className="value">
          <div className="bar-chart" style={{ width: `${chartWidth}%`, backgroundColor: color }}>
            <span>{chartWidth > 14 && formatter(total)}</span>
          </div>
          {chartWidth <= 14 && <div className="small-value">{formatter(total)}</div>}
        </div>
        <div className="exposure">{exposure}</div>
        {displayVolatility && <div className="volatility">{volatility}</div>}
      </div>
      {!singleFactor && factors.map(factor => <RiskFactor key={factor.id} {...factor} {...{ max, color, formatter, openFactorProfile, displayVolatility }} />)}
    </div>
  }
}

export default RiskCategory
